module.exports = __webpack_public_path__ + "static/media/platinumImg.1c11898e.png";